module.exports = require("./js/ngDialog.js");
require("./css/ngDialog.css");
require("./css/ngDialog-theme-default.css");


//////////////////
// WEBPACK FOOTER
// ng-dialog (bower component)
// module id = 82
// module chunks = 0